import { Align, Color, TypographyAlign, TypographyColor, alignOptions } from "../../components/typography"
import ImageEditor, { AspectRatio } from "../../Image"
import { Repeater, types } from "react-bricks/frontend"
import Typography, { TypographyElement } from "../../Typography"

import { BackgroundColor } from "../../components/layout"
import React from "react"
import { TextLinkBrickProps } from "../../text/TextLink"
import { TextLinkSize } from "../../components/text"

export interface ThreeColumnImageTextItemProps {
    text: TypographyElement[]
    index?: number
    bgColor?: BackgroundColor
    align?: TypographyAlign
}

const ThreeColumnImageTextItem: types.Brick<ThreeColumnImageTextItemProps> = ({
    index,
    bgColor,
    align = TypographyAlign.Center,
}) => {
    return (
        <li key={index} className="flex flex-col space-y-5 sm:space-y-7">
            <ImageEditor aspectRatio={AspectRatio["5/4"]} maxWidth={717} className="overflow-hidden rounded-base" />
            <Align align={align} className="space-y-3.5 sm:space-y-5">
                <Color
                    color={
                        bgColor === BackgroundColor.Green || bgColor === BackgroundColor.DarkBlumine
                            ? TypographyColor.White
                            : TypographyColor.Darkgrey
                    }
                >
                    <Typography block="copytext-small" allowList={["h5", "small", "sup", "link", "bold"]} />
                </Color>
                <Repeater propName="repeater" itemProps={{ size: TextLinkSize.Small } as TextLinkBrickProps} />
            </Align>
        </li>
    )
}

ThreeColumnImageTextItem.schema = {
    name: "ThreeColumnImageTextItem",
    label: "Image Text Item",
    previewImageUrl: `${process.env.IMG_CDN_URL_ASSETS}/lavita.de/startseite/screenshots_bricks/3ColumnImageText.png`,
    hideFromAddMenu: true,
    repeaterItems: [
        {
            name: "repeater",
            items: [
                {
                    type: "TextLink",
                    label: "Text Link",
                    max: 1,
                },
            ],
        },
    ],
    sideEditProps: [
        {
            name: "align",
            label: "Align",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: alignOptions,
                display: types.OptionsDisplay.Select,
            },
        },
    ],
    getDefaultProps: (): ThreeColumnImageTextItemProps => ({
        align: TypographyAlign.Center,
        text: [
            {
                type: "h5",
                children: [
                    {
                        text: "Lorem ipsum dolor sit amet, consetetur",
                        bold: true,
                    },
                ],
            },
            {
                type: "paragraph",
                children: [
                    {
                        text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.",
                    },
                ],
            },
        ],
    }),
}

export default ThreeColumnImageTextItem
